import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import type { OfferDetail, OfferWrite } from 'types/api'
import { BaseParams } from 'types/utils'

export function useUpdateStatus(handleSuccess?: (data: OfferDetail) => void) {
  const toast = useToast()
  const queryClient = useQueryClient()
  const onError = useOnError() // Added useOnError

  const { t } = useTranslation('offers') // Added translation hook

  async function updateStatus({ id, body }: BaseParams<OfferWrite, 'PATCH'>) {
    const res = await apiClient.patch<OfferDetail>(
      `${SNA_PREFIX}offers/${id}/`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: updateStatus,
    onSuccess: (data) => {
      toast.success({ message: t('toast.offerUpdated') })
      queryClient.invalidateQueries({ queryKey: ['offers-detail'] })
      handleSuccess?.(data)
    },
    onError // Updated to use useOnError
  })
}
